export default function Skills() {
  return (
    <div>
      <h2 className="heading">Skills</h2>
      <div>
        <div className="subheading">
          Here’s the stack behind the solutions — the languages, libraries, and
          tools that shape my work.
        </div>
        <div className="skills">
          <div>
            <span className="green">let</span> programmingSkills{" "}
            <span className="green">=</span> <span className="blue">[</span>{" "}
            Python, JavaScript <span className="blue">]</span>
            <span className="green">;</span>
          </div>
          <div>
            <span className="green">let</span> frameworksAndLibraries{" "}
            <span className="green">=</span> <span className="blue">[</span>{" "}
            React.js, Node.js, Express.js, PostgreSQL, RESTful APIs, Jest, HTML,
            Sass <span className="blue">]</span>{" "}
            <span className="green">;</span>
          </div>
          <div>
            <span className="green">let</span> relevantToolsAndSkills{" "}
            <span className="green">=</span> <span className="blue">[</span>{" "}
            Docker, Postman, Git, Jira, Scrum, CI/CD, Figma, Tailwind, Excel{" "}
            <span className="blue">]</span>
            <span className="green">;</span>
          </div>
          <div>
            <span className="green">let</span> otherLanguages{" "}
            <span className="green">=</span> <span className="blue">[</span>{" "}
            English, French, British Sign Language{" "}
            <span className="blue">]</span> <span className="green">;</span>
          </div>
        </div>
      </div>
    </div>
  );
}
